//@flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, type IntlShape } from 'react-intl';

import { showDialogPanel } from 'state/commands/dialogPanelCommands';
import { syncMappings as syncMappingsCommand } from 'state/commands/dirSvcCommands';
import type { Dispatch } from 'state/types';
import localizedStrings from 'util/localizedStrings';
import { bindActionCreatorsSafe } from 'util/safeDispatch';
import DirectoryServiceDescriptionPage from './DirectoryServiceDescriptionPage';
import { getActivePanelId } from 'state/selectors';
import { DIR_SVC_MAPPINGS_PANEL_ID } from 'util/constants';
import DirectoryServicesMappingsPage from './DirectoryServicesMappingsPage';

type Props = {
  activePanelId?: string,
  getActivePanelId: typeof getActivePanelId,
  intl: IntlShape,
  showDialogPanel: typeof showDialogPanel,
  syncMappingsCommand: typeof syncMappingsCommand,
};

class DirectoryServicesPage extends Component<Props> {
  handleShowMappings: Function;
  handleSync: Function;

  constructor() {
    super();
    this.handleShowMappings = this.handleShowMappings.bind(this);
    this.handleSync = this.handleSync.bind(this);
  }

  handleSync() {
    const {
      intl: { formatMessage },
      syncMappingsCommand,
    } = this.props;
    const msg = formatMessage(localizedStrings.LDAP_SYNC_NOTIFICATION);
    syncMappingsCommand(msg);
  }

  handleShowMappings() {
    this.props.showDialogPanel(DIR_SVC_MAPPINGS_PANEL_ID);
  }

  render() {
    const { activePanelId } = this.props;
    return (
      <div className="page" data-test-name="directory-services-page">
        <header className="page-header">
          <div className="dir-svc-page-header">
            <div>
              <FormattedMessage
                {...localizedStrings.DIRECTORY_SERVICES_TITLE}
              />
            </div>
            <div className="buttons">
              <a
                className="button is-primary is-inverted is-outlined"
                data-test-name="directory-services-configuration"
                onClick={this.handleShowMappings}
              >
                {/* <FormattedMessage {...localizedStrings.VIEW_EDIT_MAPPINGS} /> */}
                <span className="icon">
                  <i className="fa fa-user-plus" />
                </span>
                <FormattedMessage
                  {...localizedStrings.DIRECTORY_SERVICE_MAPIINGS_TITLE}
                />
              </a>
              &nbsp;&nbsp;
              <a
                className="button is-primary is-inverted is-outlined"
                data-test-name="synchronize-now"
                onClick={this.handleSync}
              >
                <span className="icon">
                  <i className="fa fa-refresh" />
                </span>
                <FormattedMessage {...localizedStrings.SYNCHRONIZE_NOW} />
              </a>
            </div>
          </div>
        </header>

        <DirectoryServiceDescriptionPage />

        {activePanelId === DIR_SVC_MAPPINGS_PANEL_ID && (
          <DirectoryServicesMappingsPage />
        )}
      </div>
    );
  }
}

export default connect(
  state => ({
    activePanelId: getActivePanelId(state),
  }),
  (dispatch: Dispatch) =>
    bindActionCreatorsSafe({
      showDialogPanel,
      syncMappingsCommand,
    })
)(injectIntl(DirectoryServicesPage));



// WEBPACK FOOTER //
// ./src/view/Pages/DirectoryServicesPage/DirectoryServicesPage.js